module.exports = __webpack_public_path__ + "img/ANAD.b5679c39.jpeg";